import type { ButtonConfig } from '../../declare'
import { useMemo, useContext } from 'react'
import { EasyModal, EasyIcon, EditPage, TreeContext } from 'src/components'

type Props = {
  config: ButtonConfig
}

const EditModalBtn = (props: Props) => {
  const tree = useContext(TreeContext)

  const formData = useMemo(() => {
    return { formId: tree.selectedNodes[0]?.Node?.ID }
  }, [tree.selectedNodes[0]?.Node?.ID])

  const { LABEL, ICON, FORM_CODE, WIDTH } = props.config
  const formCode = FORM_CODE || tree.treeConfig.Nav_Form?.CODE
  return (
    <EasyModal
      modal={{ title: formCode, width: WIDTH }}
      slot={<EasyIcon title={LABEL} type={ICON} defaultIcon='EditOutlined' />}
      onClose={() => tree.getTreeData()}
    >
      <EditPage formCode={formCode} formData={formData} />
    </EasyModal>
  )
}

export default EditModalBtn